import {del, get, post, put} from "@/util/request";
import {API} from "../../../typings";
// 获取菜单
export async function getMenu(params: API.RequestParams = {}) {
    return get("/sys/menu/tree", params?.body, params?.onSuccess, params?.onFail, params?.onFinally);
}
// 添加菜单
export async function menuAdd(params: API.RequestParams = {}) {
    return post("/sys/menu/save", params?.body, params?.onSuccess, params?.onFail, params?.onFinally);
}
// 编辑菜单
export async function menuUpdate(params: API.RequestParams = {}) {
    return post(`/sys/menu/update`, params?.body, params?.onSuccess, params?.onFail, params?.onFinally);
}
// 删除菜单
export async function deleteMenus(params: API.RequestParams = {},id:any) {
    return post(`/sys/menu/delete/${id}`, params?.body, params?.onSuccess, params?.onFail, params?.onFinally);
}
// 获取菜单信息
export async function menuInfo(params: API.RequestParams = {},id:any) {
    return get(`/sys/menu/info/${id}`, params?.body, params?.onSuccess, params?.onFail, params?.onFinally);
}
// 获取用户的菜单和权限信息
export async function getMenuAuth(params: API.RequestParams = {}) {
    return get(`/sys/menu/nav`, params?.body, params?.onSuccess, params?.onFail, params?.onFinally);
}
// 获取登录用户有权限管理的所有菜单
export async function getAllMenu(params: API.RequestParams = {}) {
    return get(`/sys/menu/perm`, params?.body, params?.onSuccess, params?.onFail, params?.onFinally);
}